import { FormEvent } from "react";
import { useNavigate } from "react-router-dom";

export class ControlledSubmitError extends Error {
	constructor(message: string) {
		super(message);
		this.name = 'ControlledSubmitError';
	}
}

interface UseSubmitFormOptions {
	onSuccess?: (shouldRedirect: boolean) => void;
	onSuccessWithResponse?: (response: any, shouldRedirect: boolean) => boolean | void;
	onError?: (error: unknown, shouldRedirect: boolean) => void;
	redirectPath?: string;
	redirectDelay?: number;
	showSuccessBeforeRedirect?: boolean;
}

export const useSubmitForm = <TData>(
	mutationFn: (data: TData) => any,
	options?: UseSubmitFormOptions
) => {
	const navigate = useNavigate();

	const handleSubmit = async (
		e: FormEvent,
		formData: TData,
		shouldRedirect: boolean = true
	) => {
		e.preventDefault();
		try {
			const response = await mutationFn(formData);

			if (options?.onSuccess) {
				options.onSuccess(shouldRedirect); // <-- wywołanie z argumentem
			}

			if (options?.onSuccessWithResponse) {
				const handledRedirect = options.onSuccessWithResponse(response, shouldRedirect); // <-- przekazujemy
				if (handledRedirect === true) {
					return;
				}
			}

			if (shouldRedirect) {
				if (options?.showSuccessBeforeRedirect) {
					setTimeout(() => {
						navigate(-1);
					}, options.redirectDelay || 2000);
				} else {
					if (options?.redirectDelay) {
						setTimeout(() => {
							navigate(-1);
						}, options.redirectDelay);
					} else {
						navigate(-1);
					}
				}
			}
		} catch (error) {
			if (error instanceof ControlledSubmitError) {
				return;
			}

			options?.onError?.(error, shouldRedirect);
			console.error("Błąd zapisu:", error);
		}
	};

	return { handleSubmit };
};
